import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import css from './CertificationBadge.module.css';

/**
 * CertificationBadge component displays a badge indicating whether the author/farmer is certified
 *
 * @component
 * @param {Object} props
 * @param {boolean} props.isVerified - Whether the farmer holds official certification
 * @param {string} [props.className] - Additional CSS class
 * @returns {JSX.Element}
 */
const CertificationBadge = props => {
  const { isVerified, className } = props;
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const buttonRef = React.useRef(null);

  const badgeClasses = classNames(
    css.badge,
    {
      [css.verified]: isVerified,
      [css.notVerified]: !isVerified,
    },
    className
  );

  const handleShowTooltip = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top - 10,
        left: rect.left,
      });
    }
    setShowTooltip(true);
  };

  return (
    <div className={css.root}>
      <button
        ref={buttonRef}
        className={badgeClasses}
        onMouseEnter={handleShowTooltip}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (!showTooltip) {
            handleShowTooltip();
          } else {
            setShowTooltip(false);
          }
        }}
        type="button"
        aria-label={isVerified ? 'Producción certificada' : 'Producción sin certificación oficial'}
      >
        {
          isVerified ? (<div className={`${css.badgeSvg} ${css.green}`}>✅Certificado</div>) : (<div className={`${css.badgeSvg} ${css.gray}`}>❌No certificado</div>)
        }
       
      </button>

      {showTooltip && (
        <div
          className={css.tooltip}
          role="tooltip"
          style={{
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`,
            transform: 'translateY(-100%)',
          }}
        >
          <div className={css.tooltipTitle}>
            {isVerified ? (
              <FormattedMessage id="CertificationBadge.verifiedTitle" />
            ) : (
              <FormattedMessage id="CertificationBadge.notVerifiedTitle" />
            )}
          </div>
          <div className={css.tooltipText}>
            {isVerified ? (
              <FormattedMessage id="CertificationBadge.verifiedText" />
            ) : (
              <FormattedMessage id="CertificationBadge.notVerifiedText" />
            )}
          </div>
          <div className={css.tooltipArrow} style={{ left: '24px' }}></div>
        </div>
      )}
    </div>
  );
};

export default CertificationBadge;
